import React, { Fragment } from 'react';
import { BOTTOM_INDENTS, COLORS } from '@constants';
import { Button, Typography } from '@ui';
import { StyledGtmCode, StyledGtmInfo } from './styled';

export const GtmInfo = ({ title = '', code, headline = '', text = '', isValid = false }) => {
    return (
        <Fragment>
            <Typography.Text style={BOTTOM_INDENTS.M} color={COLORS.$gray60Black} type='body2'>
                {title}
            </Typography.Text>

            <StyledGtmInfo $isValid={isValid}>
                {!isValid && (
                    <Typography.Text color={COLORS.$tartRed} type='badgeMedium' style={BOTTOM_INDENTS.XXS}>
                        {headline}
                    </Typography.Text>
                )}
                <Typography.Text
                    align={isValid ? 'center' : 'left'}
                    color={isValid ? COLORS.$robinBlue : COLORS.$tartRed}
                    type='descriptor1'
                >
                    {text}
                </Typography.Text>
            </StyledGtmInfo>

            {code && (
                <StyledGtmCode>
                    <Typography.Text type='descriptor1'>{code}</Typography.Text>
                    <Button.Copy value={code} />
                </StyledGtmCode>
            )}
        </Fragment>
    );
};
